import "./Home5.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ClinicalFeatures from "./sections/ClinicalFeatures";
import Footer from "@/reusable_sections/Footer";
export default function Home5Page() {
  return <div>
      <Header />
      <Hero />
      <ClinicalFeatures />
      <Footer />
    </div>;
}